import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import useInterval from "../hooks/useInterval";

const getBuildId = async () => {
    try {
        return (await fetch("/api/build-id")).json();
    } catch (error) {
        console.log(error);
    }
};

type VersionUpgradeProps = {
    dialogProps?: {};
};

const VersionUpgrade: React.FC<VersionUpgradeProps> = ({ dialogProps }) => {
    const [open, setOpen] = React.useState(false);
    // const handleClose = () => {
    //     setOpen(false);
    // };

    // poll for version changes
    useInterval(
        () => {
            (async () => {
                try {
                    const { buildId } = await getBuildId();
                    if (
                        buildId &&
                        process.env.BUILD_ID &&
                        buildId !== process.env.BUILD_ID
                    ) {
                        // show dialog
                        setOpen(true);

                        // remove warning if user navigates away
                        window.onbeforeunload = null;
                    }
                } catch (err) {
                    console.error(err);
                }
            })();
        },
        !open ? 30000 : null
    );

    return (
        <Dialog
            open={open}
            // onClose={handleClose}
            // onEscapeKeyDown={handleClose}
            // onBackdropClick={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            {...dialogProps}
        >
            <DialogTitle id="alert-dialog-title">
                New App Version Available
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Please refresh the page to get the latest version.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="text"
                    color="inherit"
                    autoFocus={true}
                    onClick={() => window.location.reload()}
                >
                    Reload Now
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export { VersionUpgrade };
export default VersionUpgrade;
